<template>
  <div class="pb-12" v-if="serverData">
    <DashboardAsnFloorGroup
      :counters="counters"
      :items="items"
      :headers="headers"
    />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import getPusherInstance from "@/core/services/pusher.service";
import DashboardAsnFloorGroup from "@/own/components/dashboard/DashboardAsnFloorGroup.vue";
export default {
  components: { DashboardAsnFloorGroup },
  name: "DashboardAsn",
  data: () => ({
    headers: [],
    items: [],
    counters: [],
    serverData: null,
    pusher: null,
    channel: null,
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.loadInitialDataFromServer();
  },
  beforeDestroy() {
    if (this.pusher) {
      if (this.channel) {
        this.channel.unbind_all();
      }
      this.pusher.unsubscribe(this.userSocketData.channel);
    }
  },
  methods: {
    loadInitialDataFromServer() {
      let filterData = {
        date_range_type: "custom",
        date_range: ["2021-01-15", "2021-02-14"],
      };
      ApiService.post("/dashboards/dashboardAsn", filterData)
        .then((response) => {
          this.serverData = response.data;
          this.counters = response.data.counters;
          this.headers = response.data.datatable.header;
          this.items = response.data.datatable.body;
          this.pusher = getPusherInstance();
          this.channel = this.pusher.subscribe("dashboard.asn");
          this.initSocketConnection(response.data.event);
          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .catch((error) => {})
        .finally(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    initSocketConnection: function (eventName) {
      this.channel.bind(`${eventName}`, (notification) => {
        // console.log("socket data:", notification);
        this.serverData = notification;
        this.counters = notification.counters;
        this.headers = notification.datatable.header;
        this.items = notification.datatable.body;
      });
    },
  },
  computed: {
    userSocketData: function () {
      /**
       * @type {{key:string,wsHost:string,wsPort:number,wssPort:number,channel:string,event:string}}
       * @example {"key":"BKFNMJNMGF","wsHost":"apitest.iqfulfillment.com","wsPort":6001,"wssPort":6001,"channel":"user.127","event":".notification.created"}
       */
      const socketData = this.$store.getters.getSocketData;
      return socketData;
    },
  },
};
</script>
